
import {
    axios
} from '@/utils/request'

const list = (parameter) => {
    return axios({
        url: '/pmsElevator/list',
        method: 'post',
        data: parameter
    })
}
const category = (parameter) => {
    return axios({
        url: '/pmsCategory/list',
        method: 'post',
        data: parameter
    })
}
const add = (parameter) => {
    return axios({
        url: '/pmsElevator',
        method: 'post',
        data: parameter
    })
}
const load = (parameter) => {
    return axios({
        url: '/pmsElevator/toLead',
        method: 'post',
        data: parameter
    })
}
const update = (parameter) => {
    return axios({
        url: '/pmsElevator',
        method: 'PUT',
        data: parameter
    })
}
const del = (parameter) => {
    return axios({
        url: '/pmsElevator',
        method: 'delete',
        params: parameter
    })
}
export {
    list,
    category,
    add,
    update,
    del,
    load
}
